import styled from 'styled-components';
import {theme} from 'charts/components/style';

export const PopoverBackground = styled.div`
  font-family: ${theme.fonts.primaryFontFamily};
  color: ${theme.colors.primaryElement};
  background-color: white;
  box-shadow: 0 0 5px #777;
  border-radius: 2px;
  padding: 10px;
  margin: 5px;

  label,
  span {
    margin: 3px 0;
    padding: 0;
    font-size: 13px;
  }

  h1 {
    font-size: 16px;
    margin: 5px 0;
    padding: 0;
  }
`;

export const FlexWrap = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding-top: 5px;
`;

export const BlueButton = styled.button`
  border: none;
  text-align: center;
  font-weight: bold;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 4px 2px;
  cursor: pointer;
  background-color: #3877f9;
  color: white;
  padding: 5px 10px;
  border-radius: 2px;
`;

export const PopoverRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  label {
    padding-right: 10px;
  }
  span {
    font-weight: bold;
  }
`;
